module.exports = __webpack_public_path__ + "img/banner-1.b777e62c.jpg";